import TextField, { TextFieldProps } from "@mui/material/TextField";
import React from "react";

interface IIntegerInput extends TextFieldProps<"outlined"> {
  value: string | null;
  // eslint-disable-next-line no-unused-vars
  handleChange: (newValue: string | null) => void;
  label: string;
  min?: number;
  max?: number;
}

const IntegerInput: React.FC<IIntegerInput> = ({ value, handleChange, label, min, max, ...rest }) => {
  const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    if (/^\d*$/.test(inputValue)) {
      handleChange(inputValue);
    }
  };

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      onChange={handleChangeValue}
      type="number"
      inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
        min: min ?? 0,
        max: max ?? Infinity,
      }}
      {...rest}
    />
  );
};

export default IntegerInput;
